export default __webpack_public_path__ + "static/media/bl.bc30dda6.jpg";